import type { PickClientAppDataConfigProps } from '@ori/client-app-config';
import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { NovageSkincareAdvisorController } from '@ori/novage-skincare-advisor';
import type { FC } from 'react';

export type AppProps = PickClientAppDataConfigProps<
  'currentLanguage' | 'globalApiUrl' | 'graphqlUrl' | 'staticApiUrl' | 'tenant'
>;
export const App: FC<AppProps> = ({ currentLanguage, tenant, staticApiUrl, graphqlUrl, globalApiUrl }) => (
  <ServiceUrlsProvider
    serviceUrls={{
      staticApiUrl,
      graphQlUrl: graphqlUrl,
      globalApiUrl,
    }}
  >
    <EnvironmentProvider tenant={tenant}>
      <TranslationsProvider
        defaultTranslationsWithNamespaces={{}}
        language={currentLanguage}
        translationsWithNamespaces={{}}
      >
        <NovageSkincareAdvisorController />
      </TranslationsProvider>
    </EnvironmentProvider>
  </ServiceUrlsProvider>
);
